import { http } from '@/core/api/';

const baseApiURL = 'api/studentevaluation';

export const getInitFilters = () => {
  return http.get(`${baseApiURL}/evaluationsdiscussion/initfilters`);
};

export const getHistory = (searchParams, pageIndex, pageSize) => {
  return http.get(`${baseApiURL}/evaluationsdiscussion/history`, {
    params: { ...searchParams, pageIndex, pageSize },
  });
};

export const getGeneralInformation = (id) => {
  return http.get(
    `${baseApiURL}/evaluationsdiscussion/generalinformation/${id}`
  );
};

export const getCenters = (academicYearId) => {
  return http.get('api/location/centers', {
    params: {
      academicYearId,
    },
  });
};

export const getMunicipalities = (academicYearId, centerId) => {
  return http.get('api/location/municipalities', {
    params: {
      academicYearId,
      centerId,
    },
  });
};

export const getSchools = (academicYearId, centerId, municipalityId) => {
  return http.get('api/location/schools', {
    params: {
      academicYearId,
      centerId,
      municipalityId,
    },
  });
};

export const getAppointmentInformation = (studentReferralId) => {
  return http.get(
    `${baseApiURL}/evaluationsdiscussion/appointmentinformation/${studentReferralId}`
  );
};
